import { render } from "./Outbox.vue?vue&type=template&id=f113d424&scoped=true"
import script from "./Outbox.vue?vue&type=script&lang=js"
export * from "./Outbox.vue?vue&type=script&lang=js"

import "./Outbox.vue?vue&type=style&index=0&id=f113d424&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f113d424"]])

export default __exports__